<template>
  <div id="app">
    <router-link :to="{name: 'home'}">
      <img src="./assets/logo.png" alt="SARP" style="width: 224px;" class="brand">
    </router-link>
    <div class="panel panel-default" style="min-width: 400px; display: inline-block; margin-bottom: 150px">
      <router-view/>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    created() {
      if(!this.getEmail){
        this.$router.push({name: 'home'});
      }
    },

    computed: {
      ...mapGetters({
        getEmail: 'getEmail'
      }),
      email: {
        get() {
          return this.getEmail
        },
        set(val) {
          this.$store.commit('SET_EMAIL', val)
        }
      }
    },
  }
</script>

<style lang="less">
@import "assets/less/styles.less";

body {
  width: 100vw;
  height: 100vh;
  background: #e6e7e8;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  text-align: center;
  color: #2c3e50;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

  .brand {
    padding-bottom: 30px;
  }
</style>
